import ContentHelmet from './ContentHelmet';

export default ContentHelmet;
